module.exports = __webpack_public_path__ + "img/social-networker.93407d94.svg";